import { removeToken, setToken } from "../../setup/api";

// 🎉

export default {
  login(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signin", data)
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setUser", response.data);
          context.commit("setLogged", true);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  register(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signup", data)
        .then(function(response) {
          setToken(response.data.token);
          context.commit("setLogged", true);
          context.dispatch("postLogin", null, { root: true });
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  forgot(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/forgot-password", data)
        .then(resolve)
        .catch(reject);
    });
  },

  resetPassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/reset-password", data)
        .then(resolve)
        .catch(reject);
    });
  },

  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/")
        .then(function(response) {
          context.commit("setUser", response.data);
          if (window.FS) {
            window.FS.identify(response.data.id, {
              displayName: response.data.name,
              email: response.data.email
            });
          }
          resolve(response.data);
        })
        .catch(function(error) {
          if (
            error.response.status === 401 ||
            error.response.data.code === "token_not_valid"
          ) {
            removeToken();
          }
          reject(error);
        });
    });
  },
  getInfo(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/info")
        .then(function(response) {
          context.commit("setAccountInfo", response.data);
          context.commit("setUser", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/info", data)
        .then(function() {
          context.commit("updateUser", data);
          resolve();
        })
        .catch(reject);
    });
  },

  updatePassword(context, { newPassword, oldPassword }) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-password", {
          password: newPassword,
          password_old: oldPassword
        })
        .then(resolve)
        .catch(reject);
    });
  },
  getCoProducers(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/accounts/co-producer?${queryString}`)
        .then(response => {
          context.commit("setCoProducers", response.data.results);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getCoProducer(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/accounts/co-producer/${id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getCoProducerByProduct(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/accounts/co-producer-by-product/${params.id}?${queryString}`)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setCoProducers", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve({ data: { count, next, previous, results } });
        })
        .catch(reject);
    });
  },
  postCoProducer(context, email) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/accounts/co-producer`, { email })
        .then(resolve)
        .catch(reject);
    });
  },
  postCoProducerProduct(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/accounts/co-producer-product`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  putCoProducerProduct(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/accounts/co-producer-product/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  putCoProducer(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/accounts/co-producer/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteCoProducer(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/accounts/co-producer/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  deleteCoProducerProduct(context, id) {
    return new Promise((resolve, reject) => {
      return window.axios
        .delete(`/accounts/co-producer-product/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  getBankAccounts(context) {
    return new Promise(resolve => {
      return setTimeout(() => {
        resolve();
      }, 100);
    });
  },
  getMyCoproducer(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/accounts/my-coproducer?${queryString}`)
        .then(({ data: { results, next, previous, count } }) => {
          context.commit("setMyCoproducers", results);
          context.commit("setPagination", { next, previous, count });
          resolve({ results });
        })
        .catch(reject);
    });
  },
  updateMyCoproducer(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/accounts/my-coproducer/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  getAchievements(context) {
    return new Promise(resolve => {
      return setTimeout(() => {
        resolve();
      }, 100);
    });
  },

  getSurvey(context) {
    return new Promise((resolve, reject) => {
      return window.axios
        .get(`/accounts/signup/survey/questions`)
        .then(({ data }) => {
          context.commit("setSurvey", data);
          resolve(data);
        });
    });
  },
  submitSurvey(context, data) {
    return new Promise((resolve, reject) => {
      return window.axios
        .post(`/accounts/signup/survey/answers`, data)
        .then(resolve)
        .catch(reject);
    });
  }
};
